var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg819",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs823"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath833"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path831"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g825",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g829",
    clipPath: "url(#clipPath833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g835",
    transform: "translate(496.9976,226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 60 l -34.016,4.127 c -5.326,32.509 -18.032,62.461 -36.47,88.131 l 20.405,26.235 -42.426,42.425 -26.235,-20.405 c -25.668,18.439 -55.622,31.145 -88.131,36.471 L -211,271 h -60 l -4.127,-34.016 c -32.509,-5.326 -62.463,-18.032 -88.13,-36.471 l -26.236,20.405 -42.425,-42.425 20.405,-26.235 c -18.439,-25.67 -31.145,-55.622 -36.471,-88.131 L -482,60 V 0 l 34.016,-4.127 c 5.326,-32.509 18.032,-62.461 36.471,-88.129 l -20.405,-26.235 42.425,-42.427 26.236,20.405 c 25.667,-18.439 55.621,-31.145 88.13,-36.471 L -271,-211 h 60 l 4.127,34.016 c 32.509,5.326 62.463,18.032 88.131,36.471 l 26.235,-20.405 42.426,42.427 -20.405,26.235 c 18.438,25.668 31.144,55.62 36.47,88.129 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path837"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g839",
    transform: "translate(120.9976,346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 45",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path841"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g843",
    transform: "translate(225.9976,346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 165",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path845"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g847",
    transform: "translate(120.9976,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 165",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g851",
    transform: "translate(345.9976,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 45",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path853"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g855",
    transform: "translate(120.9976,166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 45",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path857"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g859",
    transform: "translate(225.9976,166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 165",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g863",
    transform: "translate(225.9976,346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-16.569 -13.431,-30 -30,-30 -16.568,0 -30,13.431 -30,30 0,16.569 13.432,30 30,30 C -13.431,30 0,16.569 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g867",
    transform: "translate(345.9976,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-16.569 -13.431,-30 -30,-30 -16.568,0 -30,13.431 -30,30 0,16.569 13.432,30 30,30 C -13.431,30 0,16.569 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path869"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g871",
    transform: "translate(225.9976,166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-16.569 -13.431,-30 -30,-30 -16.568,0 -30,13.431 -30,30 0,16.569 13.432,30 30,30 C -13.431,30 0,16.569 0,0 Z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 30,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path873"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/settingIcon.39a72e7b78f3095cd7c793a482cd3eb4.svg";
export { ForwardRef as ReactComponent };